import { useDispatch, useSelector } from "react-redux";
import "../../css/MyPage.css";
import { useEffect } from "react";
import { postPopupTrue } from "../repo/PopupAPI";
import { popupOpenState } from "../../../../common/redux/action/PopupAction";
import {
  PopupButton,
  PopupMainText2,
  PopupNoButton,
  PopupTitle2,
} from "../../css/ModalStyld";
export default function PopupModal2({ isOpen, onClose, onBackPopup }) {
  const dispatch = useDispatch();
  const popupData = useSelector((state) => state.popUpState?.popupData?.[0]);

  // useEffect(() => {
  //   console.log("미동의 팝업", popupData);
  // }, [popupData]);

  if (!isOpen) return null;

  const handleBack = () => {
    onBackPopup();
  };
  const handleFail = async () => {
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-modal-box">
          {/* <div className="popup-img-box">
            <img
              src="/group.svg"
              style={{
                width: `100%`,
                height: `100%`,
              }}
            />
          </div> */}
          {/* todo : 너무 길어지면 아래위 스크롤 적용 예정 */}
          <div
            style={{
              display: `flex`,
              flexDirection: `column`,
              alignItems: `center`,
              justifyContent: `center`,
              textAlign: `center`,
            }}
          >
            {/* <PopupTitle2>{popupData?.cancle_confrim_title}</PopupTitle2> */}
            <PopupMainText2
            // dangerouslySetInnerHTML={{
            //   __html: popupData?.cancle_confrim_content || "",
            // }}
            >
              동의하지 않을 경우, <br />
              후원은 받을 수 있으나, 출금이 어려울 수 있습니다.
            </PopupMainText2>
          </div>
          <PopupButton className="popup-button" onClick={() => handleBack()}>
            뒤로가기
          </PopupButton>
          <div
            style={{
              height: `10px`,
            }}
          ></div>
          <PopupNoButton onClick={() => handleFail()}>확인</PopupNoButton>
        </div>
      </div>
    </div>
  );
}
